import cx from 'classnames'
import Styles from './ImageThumbnail.module.scss'
import { ImageThumbnailProps } from './Types'
import { useHover } from '@react-aria/interactions'
import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'
import { useEffect, useState } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'

export const ImageThumbnail = ({ image, onToggleSelect, isSelected, label, duration }: ImageThumbnailProps) => {
  const { hoverProps, isHovered } = useHover({})
  const [error, setError] = useState(false)
  const { isMobile } = useResponsiveDesign()

  const handleSelect = () => {
    if (error) return
    onToggleSelect(image)
  }

  useEffect(() => {
    if (isSelected && error) {
      onToggleSelect(image)
    }
  }, [error, isSelected, onToggleSelect, image])

  return (
    <div
      {...hoverProps}
      className={cx(Styles.imageThumbnail, {
        [Styles.hovered]: isHovered,
        [Styles.selected]: isSelected,
        [Styles.errored]: error,
      })}
      onClick={handleSelect}
      aria-label={isSelected ? 'Selected Image' : ''}
    >
      {error ? (
        <div className={Styles.error}>Error loading image</div>
      ) : (
        <>
          <img
            alt="thumbnail preview"
            src={image.thumbnail_url || image.url}
            className={Styles.image}
            onError={() => {
              setError(true)
            }}
          />
          {duration && <VideoDuration duration={duration} />}
        </>
      )}
      {(isSelected || isHovered) && !error && (
        <div className={Styles.checkbox}>
          <Checkbox
            color="var(--selected-fill)"
            size={isMobile ? 20 : 28}
            isSelected={isSelected}
            aria-label="Select image"
          />
        </div>
      )}
      {label && <p className={Styles.label}>{label}</p>}
    </div>
  )
}
